import React, { FC, useMemo } from 'react';
import { ViewProps, StyleSheet, View } from 'react-native';
import { useTheme } from 'react-native-paper';
import { UiIcon, UiIconProps } from './SimpleListIcon';
import Typography, { TypographyProps } from './Typography';

export type CardBadgeProps = ViewProps & {
  text: string | number | undefined;
  textColor?: TypographyProps['color'];
  textStyle?: TypographyProps['style'];
  borderColor?: string;
  icon?: UiIconProps;
};

export const CardBadge: FC<CardBadgeProps> = ({ text, textColor, textStyle, borderColor, style, icon, ...other }) => {
  const { colors, roundness } = useTheme();
  const s = useMemo(() => {
    return StyleSheet.create({
      container: {
        borderWidth: 1,
        borderColor: borderColor ?? colors.primary,
        borderRadius: roundness,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 4,
        flexGrow: 0,
        flexDirection: 'row',
      },
    });
  }, [borderColor, colors.primary, roundness]);

  return (
    <View style={[s.container, style]} {...other}>
      {icon && <UiIcon color={colors.primary} size={24} {...icon} />}
      {text !== undefined && (
        <Typography
          variant={'caption'}
          color={textColor ?? colors.onSurface}
          style={[icon && { marginLeft: 4 }, textStyle]}
        >
          {text}
        </Typography>
      )}
    </View>
  );
};
